module.exports = __webpack_public_path__ + "static/image3-a5fb70c4beef6d461e25273b5366ee3f.jpg";